import { render, staticRenderFns } from "./Tall.vue?vue&type=template&id=522d9e13&"
import script from "./Tall.vue?vue&type=script&lang=js&"
export * from "./Tall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports